export default "__VITE_ASSET__DCbao6ih__"